import VQrCode from './index.vue';

export default {
  install: (Vue) => Vue.component('VQrCode', VQrCode),
};
